import { absolutePath } from "./absolutePath";

interface NotificationsFnProps {
  params?: Record<string, unknown>;
}

interface FetchParams {
  notification_group: string;
  page: string;
  per_page: string;
}

interface IdParams {
  id: string;
}

interface UnfollowParams {
  followerId: string;
  postId: string;
}

interface FollowParams {
  postId: string;
}

interface FetchNotificationCountParams {
  community_id: string;
}

export const notifications = {
  markAllAsRead: ({ params = {} }: NotificationsFnProps) =>
    absolutePath("notifications/mark_all_as_read", params),
  fetch: (params: FetchParams) => absolutePath("notifications", params),
  markAsRead: (params: IdParams) =>
    absolutePath(`notifications/${params.id}/mark_as_read`),
  archive: (params: IdParams) =>
    absolutePath(`notifications/${params.id}/archive`),
  unfollow: (params: UnfollowParams) =>
    absolutePath(`posts/${params.postId}/post_followers/${params.followerId}`),
  follow: (params: FollowParams) =>
    absolutePath(`posts/${params.postId}/post_followers`),
  resetNotificationCount: () =>
    absolutePath("notifications/reset_new_notifications_count"),
  fetchNotificationCount: (params: FetchNotificationCountParams) =>
    absolutePath(`notifications/new_notifications_count`, params),
};
